import type { AccessType } from '@/features/instructions/types'

/**
 * Доступ по возрастанию открытости: закрытый < по ссылке < в каталоге. Тем же
 * списком селект рисует строки — порядок показа и порядок сравнения обязаны
 * быть одним значением, иначе «понижение» разъедется с тем, что видит автор.
 */
export const ACCESS_ORDER: AccessType[] = ['private', 'link', 'public']

/**
 * Открывает ли переход курс шире, чем сейчас. Смысл гейта публикации (п.19) —
 * не пустить пустой видео-блок к читателям, поэтому запрещать он обязан
 * РОВНО повышение: понижение доступа гейту не противоречит, а разделы
 * каталога никого к курсу не допускают вовсе.
 */
export const isAccessRaise = (from: AccessType, to: AccessType): boolean =>
  ACCESS_ORDER.indexOf(to) > ACCESS_ORDER.indexOf(from)
